import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authReducer from "../../app/pages/AxiosRtk/Auth/authActions";
import miscellaneousReducer from "../../app/pages/AxiosRtk/Miscellaneous/misActions";
import pincodeReducer from "../../app/pages/AxiosRtk/PinCode/pincodeActions";
import dashboardReducer from "../../app/pages/AxiosRtk/DashBoard/dashBoardActions";
import addNewChildReducer from "../../app/pages/AxiosRtk/AddNewChild/addNewChildActions";
import taskReducer from "../../app/pages/AxiosRtk/Tasks/taskActions";
import settingReducer from "../../app/pages/AxiosRtk/Settings/settingAction";
import addNewParentReducer from "../../app/pages/AxiosRtk/AddNewParent/addNewParentActions";
import setRulesDataReducer from "../../app/pages/AxiosRtk/SetRules/setRulesAction";
import appActivityReducer from "../../app/pages/AxiosRtk/AppActivity/appActivityActions";
import successMessageActions from "../../app/pages/AxiosRtk/successMessage/successMessageActions";
import socialAppsReducer from "../../app/pages/AxiosRtk/SocialApps/socialAppActions";
import subscriptionActions from "../../app/pages/AxiosRtk/Subscription/subscriptionActions";

export const rootReducer = combineReducers({
  auth: persistReducer({ key: "auth", storage }, authReducer),
  misc: persistReducer({ key: "miscellaneous", storage }, miscellaneousReducer),
  pincode: persistReducer({ key: "pincodeSetup", storage }, pincodeReducer),
  dashboard: persistReducer(
    { key: "dashboardSetup", storage },
    dashboardReducer
  ),
  addNewChild: persistReducer(
    { key: "addNewChildSetup", storage },
    addNewChildReducer
  ),
  tasks: persistReducer({ key: "tasks", storage }, taskReducer),
  settings: persistReducer({ key: "settings", storage }, settingReducer),
  addNewParent: persistReducer(
    { key: "addNewParentSetup", storage },
    addNewParentReducer
  ),
  setRules: persistReducer(
    { key: "setRulesDataSetUp", storage },
    setRulesDataReducer
  ),
  appActivity: persistReducer(
    { key: "appActivityBoard", storage },
    appActivityReducer
  ),
  socialApp: persistReducer(
    { key: "socialAppSlice", storage },
    socialAppsReducer
  ),
  successData: successMessageActions,
  subscription: subscriptionActions,
});
